import React from 'react';
import clsx from 'clsx';
import { default as MUIChip, ChipProps as MUIChipProps } from '@material-ui/core/Chip';

import './Chip.css';

//
// --- Types ---

export interface ChipProps extends MUIChipProps {
  className?: string;
}

//
// --- Chip Component ---

const Chip = React.forwardRef<HTMLDivElement, ChipProps>((props, ref) => {
  const { className, ...remainingChipProps } = props;

  return <MUIChip className={clsx('chip', className)} data-testid="chip" ref={ref} {...remainingChipProps} />;
});

export default Chip;
